import { Link } from "react-router-dom";
import { Container, Row, Col, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
import { useState, useEffect } from "react";

export default function Footer() {
  return (
    <>
      <footer className="text-white pt-5 pb-4" style={{background: "#111827", color: "#f9fafb",}}>
        <div className="container">
          <div className="row gy-4">
            {/* Column 1 */}
            <div className="col-md-3">
              <h5 className="fw-bold mb-3">Premium Services</h5>
              <ul className="list-unstyled footer-links">
                <li>
                  <a href="#" className="text-white text-decoration-none">Premium Personalized Kundli</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Book Consultation Call</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Fortune Report</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Kundali Matching</a>
                </li>
              </ul>
              <h6 className="fw-bold mt-4">Contact Details</h6>
              <p className="small mb-1">📞 +91-9818999037 (Sales)</p>
              <p className="small mb-1">📞 +91-8604802202 (Support)</p>
              <p className="fw-bold mt-3 mb-1">Occult Gurukul</p>
              <p className="small mb-1">📞 +91-7236936903 (Sales)</p>
              <p className="small">📞 +91-7236936904 (Support)</p>
            </div>

            {/* Column 2 */}
            <div className="col-md-3">
              <h5 className="fw-bold mb-3">Our Courses</h5>
              <ul className="list-unstyled footer-links">
                <li>
                  <a href="#" className="text-white text-decoration-none">Basic Numerology Course</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Basic Astrology Course</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Advanced Numerology Course</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Advanced Astrology Course</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Mobile Numerology Course</a>
                </li>
              </ul>
              <h6 className="fw-bold mt-4">Astrologers</h6>
              <ul className="list-unstyled footer-links">
                <li>
                  <a href="#" className="text-white text-decoration-none">Astrologer Registration</a>
                </li>
              </ul>
            </div>

            {/* Column 3 */}
            <div className="col-md-3">
              <h5 className="fw-bold mb-3">Quick Links</h5>
              <ul className="list-unstyled footer-links">
                <li>
                  <a href="#" className="text-white text-decoration-none">Daily Horoscope</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Numerology 2025</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Destiny Number Calculator</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Collaborate With Us</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">News / PR</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Careers</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Blogs</a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">Contact Us</a>
                </li>
              </ul>
            </div>

            {/* Column 4 */}
            <div className="col-md-3">
              <h5 className="fw-bold mb-3">Stay Updated</h5>
              <form className="d-flex flex-column">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="form-control mb-2 rounded-pill"
                />
                <button
                  type="submit"
                  className="btn btn-warning rounded-pill fw-bold"
                >
                  Subscribe
                </button>
              </form>
              <p className="mt-3 small">
                Astro Portal is a leading astrologer in India, specializing
                in Astrology, Numerology & Palmistry, with 50+ years of
                experience helping people worldwide.
              </p>
            </div>
          </div>

          {/* Footer bottom */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center border-top border-light pt-3 mt-4">
            <p className="mb-2 mb-md-0 small">
              © {new Date().getFullYear()} Astro Portal. All rights
              reserved.
            </p>

            <ul className="list-inline mb-2 mb-md-0">
              <li className="list-inline-item">
                <a href="#" className="text-white text-decoration-none">Terms & Services</a>
              </li>
              <li className="list-inline-item">
                <a href="#" className="text-white text-decoration-none">Privacy Policy</a>
              </li>
              <li className="list-inline-item">
                <a href="#" className="text-white text-decoration-none">Refund Policy</a>
              </li>
            </ul>

            <div className="social-icons">
              <a href="#" className="text-white text-decoration-none me-3">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="text-white text-decoration-none me-3">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="text-white text-decoration-none me-3">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="#" className="text-white text-decoration-none me-3">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#" className="text-white text-decoration-none">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
